import React from "react";
import { getResponsiveImage } from "../../utils/imageHelper";


/*eslint-disable */

declare const window: any;

interface OtrosVehiculosDinamicoComponentProps {
  opportunities: any;
}

const OtrosVehiculosDinamicoComponent: React.FC<
  OtrosVehiculosDinamicoComponentProps
> = ({ opportunities }) => {
  return (
    <div className="otros-vehiculos-detail-component">
      {/* H2 - Título de la sección */}
      <h2 className="title-otros-vehiculos-detail-component">
        Más oportunidades
      </h2>
      
      <div className="opciones-otros-vehiculos-detail-component">
        {opportunities?.map((item: any, index: number) => (
          <div
            key={index}
            className={`item-opciones-otros-vehiculos-detail-component`}
            style={{
              backgroundImage:
                `URL(${getResponsiveImage(item?.image?.url || item?.media[0]?.url || '').desktop})`,
            }}

          >
            <div
              className={`mascara-item-opciones-otros-vehiculos-detail-component`}
            >
              {/* H3 - Título de la oportunidad */}
              <h3 className="title-mascara-item-opciones-otros-vehiculos-detail-component">
                {item?.title}
              </h3>
              
              <a
                href={item?.url}
                className="btn-page-other-page-home-component"
              >
                {item?.button_text || item?.title}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtrosVehiculosDinamicoComponent;